
  
  <div class="chatIcon shadow" id="tool" data-bs-toggle="modal" data-bs-target="#exampleModals">
    <span class="p-2">
        <img src="./assets/images/callold.png" class="img-fluid rounded-circle" alt="" srcset="">
    </span>
  </div>

  <div class="modal fade" id="exampleModals" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div> -->
        <div class="modal-body p-5 fw-bold">
            Do you want our support person to contact you?
        </div>
        <div class="modal-footer justify-content-center p-3">
          <button type="button" class="btn btn-custom px-4" data-bs-dismiss="modal">No</button>
          <button type="button" class="btn btn-primary px-4" data-bs-dismiss="modal" (click)="contactUs()">Yes</button>
        </div>
      </div>
    </div>
  </div>